<div
  class="orgApp-d-flex orgApp-empty-p-main-div orgApp-flex-dir-col orgApp-justify-c-center"
  [style.height]="secHt === 0 ? '100%' : secHt + 'px'"
  [style.width]="avlblWidth === 0 ? '100%' : avlblWidth + 'px'"
>
  <div
    class="orgApp-text-center orgApp-plan-welcome-div orgApp-padding-left-24 orgApp-padding-right-24 orgApp-padding-top-24 orgApp-padding-bottom-24"
  >
    <svg width="72" height="72" class="orgApp-config-card-btn-svg">
      <use [attr.xlink:href]="'#' + icon"></use>
    </svg>
    <h1>
      {{ title }}
      @if(selMonthName !== ''){
        <span>
          {{ selMonthName | translate
          }}
        </span>
      }
    </h1>
    <p class="orgApp-para-font-color">
      {{ description }}
    </p>
  </div>
</div>
